import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import * as GetOrgConfig from "./useOrgConfig";

export function useUpdateOrgConfig() {
  const { configService } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      orgId,
      key,
      value,
    }: {
      orgId: string;
      key: string;
      value: unknown;
    }) => {
      return configService.setOrgConfig(orgId, key, value);
    },
    onSuccess: (_, { orgId, key, value }) => {
      return queryClient.setQueryData(
        GetOrgConfig.getQueryKey(orgId, key),
        value,
      );
    },
  });
}
